// extracted by mini-css-extract-plugin
export default {"container":"Select_container__levv0","main":"Select_main__OmonS","rotate":"Select_rotate__i5cPC","options":"Select_options__nUKHX","option":"Select_option__MsRL5"};